module.exports = __webpack_public_path__ + "img/ry_banner.06404c81.png";